import './App.css';
import HomePageImgFamilyOneWeb from './img/ContactsBanner.jpg';

import { Col, Grid, Row, Typography, Button } from 'antd';
import { NavLink } from "react-router-dom";

const { Title } = Typography;

function Contacts() {
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;
    return (
        <Row className={'page-row'} style={{
            minHeight: 220,
            maxWidth: 1024,
            margin: isMobile ? '24px auto 48px auto' : '72px auto'
        }}>
            <Col xs={24} md={12} style={{ padding: isMobile ? "0 0 32px 0" : "148px 0" }}>
                <Title level={1} style={{ color: "#513f38" }}>We're here to help, <br />24/7</Title>
                <Title level={5} style={{ paddingRight: isMobile ? 0 : 48, color: "#513f38" }}>Whether you want to browse our Help Centre for solutions or chat with us directly, we’ve got you.</Title>
                <br />
                <br />
                <NavLink className={"menu"} target={'_blank'} to={'https://rekvizitai.vz.lt/imone/amber_information_technologies/'}>
                    <Button size='large' color="default" variant="solid">
                        Contacts
                    </Button>
                </NavLink>
            </Col>

            <Col xs={24} md={12}>
                <div style={{
                    borderRadius: 24,
                    backgroundImage: `url(${HomePageImgFamilyOneWeb})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    height: isMobile ? "360px" : "600px",
                    position: "relative",
                }}>
                </div>
            </Col>
        </Row>
    );
}

export default Contacts;
